export default __webpack_public_path__ + "static/media/info-circle-solid.d8f675d6.svg";